import React from 'react';
import { useMobileView } from 'hooks/useMobileView';

export const useUpdateMobileClass = () => {
    const isMobile = useMobileView();

    React.useEffect(() => {
        if (isMobile) {
            document.body.classList.add('mobile');
            return;
        }

        document.body.classList.remove('mobile');
    }, [isMobile]);
};
